import { withParams } from '@rst/libs-ts'
import { useStore } from 'effector-react'
import { $theme } from 'model'
import React, { useMemo } from 'react'
import { Helmet } from 'react-helmet'

export const DevIcons = () => {
	const { icons = 'material-icons' } = useStore($theme)

	const href = useMemo(
		() =>
			withParams(hrefs[icons] || hrefs['material-icons'], { v: Date.now() }),
		[icons]
	)

	return (
		<Helmet>
			<link rel="stylesheet" href={href} />
		</Helmet>
	)
}

const hrefs = {
	'line-awesome': 'https://cdn2.rsttur.ru/web/icons/line-awesome/style.css',
	'remix-icons': 'https://cdn2.rsttur.ru/web/icons/remix-icons/style.css',
	'material-icons': 'https://cdn2.rsttur.ru/web/icons/material-icons/style.css',
	'phosphor-icons': 'https://cdn2.rsttur.ru/web/icons/phosphor-icons/style.css',
	unicons: 'https://cdn2.rsttur.ru/web/icons/unicons/style.css',
	'sf-symbols': 'https://cdn2.rsttur.ru/web/icons/sf-symbols/style.css',
}
